module.exports = __webpack_public_path__ + "static/media/peugeot.4256faa8.svg";